/**
 * Wraps an async request so only the newest call's outcome is used.
 *
 * Each call resolves to one of:
 * - { status: 'ok', data }   the newest request succeeded
 * - { status: 'error' }      the newest request failed; keep what is on screen
 * - { status: 'stale' }      a newer request started; ignore this one
 *
 * @param {(params: object) => Promise<any>} fetchJson
 * @returns {(params: object) => Promise<{status: string, data?: any}>}
 */
export function createLatestRequest(fetchJson) {
  let latest = 0

  return async function request(params) {
    const id = ++latest
    try {
      const data = await fetchJson(params)
      return id === latest ? { status: 'ok', data } : { status: 'stale' }
    } catch (error) {
      return id === latest ? { status: 'error' } : { status: 'stale' }
    }
  }
}
